import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";
import ButtonPrimaryIcon from "components/buttons/ButtonPrimaryIcon";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import Backdrop from "../other/Backdrop";
import ModalWindow from "../other/ModalWindow";
import CreateAutoresponderContainer from "./CreateAutoresponderContainer";
import ButtonPrimary from "components/buttons/ButtonPrimary";

import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";
import userCircleIcon from "assets/img/icons/user-single-icon.svg";
import userCircleWhiteIcon from "assets/img/icons/user-single-icon-white.svg";
import blockIcon from "assets/img/icons/icons8-unavailable.svg";
import plusIcon from "assets/img/icons/plus-sign.svg";
import plusWhiteIcon from "assets/img/icons/plus-sign-white.svg";
import adPlanIcon from "assets/img/icons/icons8-web-advertising.svg";

const AutoresponderListWrap = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const AutoresponderList = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const ListTable = styled.table`
  width: 100%;
  min-width: 560px;
  max-width: 700px;

  border-spacing: 4px;
`;

const TableHead = styled.thead``;

const Label = styled.th`
  padding-bottom: 12px;
  max-width: ${(props) => (props.width ? props.width : "none")};

  font-size: 18px;
  font-weight: 400;
  text-align: left;
`;

const TableBody = styled.tbody``;

const Cell = styled.td`
  padding-left: ${(props) => (props.paddingleft ? props.paddingleft : "0")};
`;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};

  @media (max-width: ${globalConstants.switchTablet}) {
    margin-top: 6px;
    margin-bottom: ${css.VERTICAL_BOX_MARGIN};
  }
`;

const NoResults = styled.div`
  width: 100%;
  margin-top: 60px;
  margin-bottom: 60px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NoResultsIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const NoResultsText = styled.div`
  text-align: center;
`;

const StatusDot = styled.div`
  width: 12px;
  min-width: 12px;
  height: 12px;

  border-radius: 50%;

  background: ${(props) => props.color};
`;

const BadgeWrap = styled.div`
  display: flex;
`;

const NumOfListsBadge = styled.div`
  height: 20px;
  padding: 0 14px 1px;

  font-size: 13px;
  color: #fff;
  white-space: nowrap;

  border-radius: 10px;
  background: ${(props) => {
    switch (props.color) {
      case "green":
        return css.BRAND_GREEN;
      case "red":
        return css.NEGATIVE_RED;
      default:
        return css.NEGATIVE_RED;
    }
  }};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

const ModalWrap = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
`;

const CreateAutoresponder = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: auto;
  transform: translateX(-50%) translateY(-50%);

  width: 100%;
  max-width: 650px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 200;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 100%;
  }
`;

const DisabledModalWrap = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  max-width: 550px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 2000;
`;

const DisabledWindowContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const DisabledHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const DisabledHeadingIcon = styled.div`
  width: 36px;
  min-width: 36px;
  height: 36px;
`;

const DisabledHeadingText = styled.div`
  font-size: 24px;
`;

const DisabledText = styled.div`
  text-align: center;
  line-height: 130%;
`;

export default ({
  data,
  limit,
  page,
  paginate,
  onOpenClick,
  openCreateAutoresponderModal,
  closeCreateAutoresponderModal,
  createAutoresponderModal,
  refetch,
  disabledModal,
  onCloseDisabledModal,
}) => {
  const navigate = useNavigate();

  const numOfResults = data.responderListData.numOfResults;

  const list = data.responderListData.responders.map((responder) => {
    const { id, name, status, messages, leads, lists } = responder;

    return (
      <tr key={id}>
        <Cell>
          <StatusDot
            color={status === "active" ? css.BRAND_GREEN : css.BRAND_BLUSH}
          />
        </Cell>
        <Cell>{name}</Cell>
        <Cell>{messages.length}</Cell>
        <Cell>{leads.length}</Cell>
        <Cell>
          <BadgeWrap>
            <NumOfListsBadge color={lists.length > 0 ? "green" : "red"}>
              {lists.length}
            </NumOfListsBadge>
          </BadgeWrap>
        </Cell>
        <Cell>
          <ButtonPrimarySmall onClick={() => onOpenClick(id)}>
            Open
          </ButtonPrimarySmall>
        </Cell>
      </tr>
    );
  });

  // prepare pagination
  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  return (
    <AutoresponderListWrap>
      <AutoresponderList>
        <TableWrap className="table-wrap">
          {list.length > 0 && (
            <ListTable>
              <TableHead>
                <tr>
                  <Label width="20px"></Label>
                  <Label width="120px">Name</Label>
                  <Label width="120px">Active Emails</Label>
                  <Label width="80px">Leads</Label>
                  <Label width="120px">Mailing Lists</Label>
                  <Label width="100px"></Label>
                </tr>
              </TableHead>
              <TableBody>{list}</TableBody>
            </ListTable>
          )}
          {list.length === 0 && (
            <NoResults>
              <NoResultsIcon>
                <img src={blockIcon} style={{ width: "100%" }} />
              </NoResultsIcon>
              <NoResultsText>
                You don't have any autoresponder yet.
              </NoResultsText>
            </NoResults>
          )}
        </TableWrap>
        {showPagination && (
          <Pagination>
            {page > 1 && (
              <ButtonRoundIcon
                icon={leftIcon}
                hoverIcon={leftWhiteIcon}
                background={css.BRAND_YELLOW}
                hoverBackground={css.BRAND_GREEN}
                iconSize="16px"
                buttonSize="32px"
                onClick={() => paginate("previous")}
              />
            )}
            {page < maxPage && (
              <ButtonRoundIcon
                icon={rightIcon}
                hoverIcon={rightWhiteIcon}
                background={css.BRAND_YELLOW}
                hoverBackground={css.BRAND_GREEN}
                iconSize="16px"
                buttonSize="32px"
                onClick={() => paginate("next")}
              />
            )}
          </Pagination>
        )}
      </AutoresponderList>
      <ButtonWrap>
        <ButtonPrimaryIcon
          icon={plusIcon}
          iconHover={plusWhiteIcon}
          onClick={openCreateAutoresponderModal}
        >
          Create Autoresponder
        </ButtonPrimaryIcon>
      </ButtonWrap>
      {createAutoresponderModal && (
        <ModalWrap>
          <Backdrop
            onClick={closeCreateAutoresponderModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <CreateAutoresponder>
            <ModalWindow
              title="Create New Autoresponder"
              handleModalClose={closeCreateAutoresponderModal}
              fullScreenHeight={true}
            >
              <CreateAutoresponderContainer
                refetch={refetch}
                closeCreateAutoresponderModal={closeCreateAutoresponderModal}
              />
            </ModalWindow>
          </CreateAutoresponder>
        </ModalWrap>
      )}
      {disabledModal && (
        <ModalWrap>
          <Backdrop
            onClick={onCloseDisabledModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <DisabledModalWrap>
            <ModalWindow
              modal="changeError"
              handleModalClose={onCloseDisabledModal}
              fullScreenHeight={true}
            >
              <DisabledWindowContent>
                <DisabledHeading>
                  <DisabledHeadingIcon>
                    <img
                      src={adPlanIcon}
                      style={{ width: "100%", paddingTop: "1px" }}
                    />
                  </DisabledHeadingIcon>
                  <DisabledHeadingText>
                    Subscribe to Ad Plan
                  </DisabledHeadingText>
                </DisabledHeading>
                <DisabledText>
                  The Autoresponder feature is available only to users with an
                  active Ad plan. Please upgrade your account before creating an
                  Autoresponder.
                </DisabledText>
                <ButtonWrap>
                  <ButtonPrimary onClick={() => navigate("/advertising-plans")}>
                    Get Ad Plan
                  </ButtonPrimary>
                </ButtonWrap>
              </DisabledWindowContent>
            </ModalWindow>
          </DisabledModalWrap>
        </ModalWrap>
      )}
    </AutoresponderListWrap>
  );
};
